module.exports = __webpack_public_path__ + "static/media/Amazon_Web_Services_Logo.259e1339.svg";